import { Button, Form, Input, message } from 'antd';
import React from 'react';
import bg from './../assets/loginbg.webp';
import axios from 'axios';

function LoginLayout() {
    return (
        <div style={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'var(--gradient)',
            position: 'relative',
            overflow: 'hidden',
        }}>
            {/* Background pattern */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                opacity: 0.1,
            }} />
            
            {/* Decorative circles */}
            <div style={{
                position: 'absolute',
                width: '400px',
                height: '400px',
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.05)',
                top: '-100px',
                right: '-100px',
            }} />
            <div style={{
                position: 'absolute',
                width: '300px',
                height: '300px',
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.05)',
                bottom: '-50px',
                left: '-50px',
            }} />
            
            {/* Login card */}
            <div
                className="animate-fade-in-up"
                style={{
                    width: '100%',
                    maxWidth: '420px',
                    borderRadius: 'var(--radius-xl)',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                    backgroundColor: 'var(--bg-card)',
                    padding: '48px 40px',
                    position: 'relative',
                    zIndex: 1,
                    animation: 'fadeInUp 0.5s ease-out',
                }}
            >
                {/* Logo */}
                <div style={{
                    textAlign: 'center',
                    marginBottom: '32px',
                }}>
                    <h1 style={{
                        fontSize: '32px',
                        fontWeight: 700,
                        margin: 0,
                        background: 'var(--gradient)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                    }}>
                        G.A.M
                    </h1>
                    <p style={{
                        color: 'var(--text-secondary)',
                        marginTop: '8px',
                        fontSize: '14px',
                    }}>
                        Gabarit Avto Market
                    </p>
                </div>

                {/* Form */}
                <Form
                    name="login"
                    initialValues={{ remember: true }}
                    onFinish={(values) => {
                        axios.post('/login', values)
                            .then(response => {
                                message.success('Muvaffaqiyatli kirildi!');
                                localStorage.setItem('token', response.data.token);
                                localStorage.setItem('user', JSON.stringify(response.data.user));
                                window.location.href = '/';
                            })
                            .catch(error => {
                                message.error('Kirish xatosi!');
                            })
                    }}
                    onFinishFailed={() => { }}
                    autoComplete="off"
                    layout='vertical'
                    size='large'
                >
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[{ required: true, message: 'Email kiriting!' }]}
                    >
                        <Input 
                            placeholder="email@example.com"
                            style={{ height: '48px' }}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Parol"
                        name="password"
                        rules={[{ required: true, message: 'Parol kiriting!' }]}
                    >
                        <Input.Password 
                            placeholder="••••••••"
                            style={{ height: '48px' }}
                        />
                    </Form.Item>
                    
                    <Form.Item style={{ marginTop: '24px' }}>
                        <Button 
                            block 
                            type="primary" 
                            htmlType="submit"
                            style={{ 
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 600,
                                borderRadius: 'var(--radius-md)',
                            }}
                        >
                            Kirish
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}

export default LoginLayout;
